<template>
  <div>
    <search-form
      @handleSync="handleSync"
      @handleSearch="handleSearch"
    />
    <a-table
      :columns="table.columns"
      :data-source="table.data"
      :pagination="false"
      :loading="table.loading"
    >
      <template slot="num" slot-scope="text,record,index">
        {{ index + 1 }}
      </template>
      <template slot="subcompanyname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.subcompanyname }}</template>
          <span class="subcompanyname">{{ record.subcompanyname }}</span>
        </a-tooltip>
      </template>
      <template slot="departmentname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.departmentname }}</template>
          <span class="jobTitleName">{{ record.departmentname }}</span>
        </a-tooltip>
      </template>
      <template slot="roleNames" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.roleNames }}</template>
          <span class="assetNameTable">{{ record.roleNames }}</span>
        </a-tooltip>
      </template>
      <template slot="jobTitleName" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.jobTitleName }}</template>
          <span class="jobTitleName">{{ record.jobTitleName }}</span>
        </a-tooltip>
      </template>
      <template slot="actions" slot-scope="text,record,index" v-if="$auth('organizationalStructure.configureRoles')">
        <a href="javascript:;" @click="() => configureRoles(record)">配置角色</a>
      </template>
    </a-table>
    <a-pagination
      style="float:right;margin-top:20px"
      v-model="table.pagination.pageNum"
      :total="table.pagination.total"
      :pageSize="table.pagination.pageSize"
      show-size-changer
      @showSizeChange="onShowSizeChange"
      @change="handleTableChange"
      size="default"
      show-quick-jumper
      show-less-items
    />
    <a-modal
      v-model="visible"
      title="配置角色"
      :width="700"
      @ok="handleSubmit"
      :confirmLoading="confirmLoading"
      :maskClosable="false">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="选择角色">
          <a-select
            v-decorator="['roleUserList', { rules: [{ required: false, message: '请选择角色！' }] }]"
            mode="multiple"
            :allowClear="true"
            show-search
            :filter-option="filterOption"
            placeholder="请选择角色">
            <a-select-option v-for="(item, index) in roleList" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import searchForm from './modules/searchForm.vue'
import { getUserList, saveUserRole, setSync } from '@/api/organizationalStructure'
import { getRoleList } from '@/api/roleList'
export default {
  components: {
    searchForm
  },
  watch: {
    tableParams (newVal) {
      this.initTableData()
    }
  },
  computed: {
    tableParams () {
      return this.$store.state.organizationalStructure.tableParams
    }
  },
  data () {
    return {
      table: {
        columns: [
          {
            title: '序号',
            align: 'center',
            scopedSlots: { customRender: 'num' },
            width: 50
          },
          {
            title: '公司名称',
            dataIndex: 'subcompanyname',
            scopedSlots: { customRender: 'subcompanyname' },
            align: 'center'
          },
          {
            title: '部门',
            dataIndex: 'departmentname',
            scopedSlots: { customRender: 'departmentname' },
            align: 'center'
          },
          {
            title: '姓名',
            dataIndex: 'lastname',
            align: 'center'
          },
          {
            title: '岗位',
            dataIndex: 'jobTitleName',
            scopedSlots: { customRender: 'jobTitleName' },
            align: 'center'
          },
          {
            title: '性别',
            dataIndex: 'sex',
            align: 'center'
          },
          {
            title: '角色',
            dataIndex: 'roleNames',
            align: 'center',
            scopedSlots: { customRender: 'roleNames' },
            width: 300,
            ellipsis: true
          },
          {
            title: '操作',
            align: 'center',
            scopedSlots: { customRender: 'actions' }
          }
        ],
        data: [],
        pagination: {
          pageNum: 1, // 当前是第几页
          pageSize: 10, // 一页最大几条
          total: 0 // 总条数
        },
        searchParams: {},
        loading: false
      },
      searchModel: {},
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      // 角色列表
      roleList: [],
      // 当前配置的角色id
      configureRolesId: null
    }
  },
  created () {
    this.getRoleList()
  },
  methods: {
    // 同步数据
    async handleSync () {
      const res1 = await setSync()
      if (res1 && res1.status === 0) {
        this.$message.success(res1.info.message)
      } else {
        this.$message.warning(res1.info.message)
      }
    },
    // 获取table数据
    async initTableData () {
      this.table.loading = true
      let params = {
        depid: this.tableParams.depid === '杭氧' ? '' : this.tableParams.depid,
        comid: this.tableParams.comid === '杭氧' ? '' : this.tableParams.comid,
        ...this.searchModel
      }
      params = Object.keys(params)
        .filter((key) => params[key])
        .reduce((acc, key) => ({ ...acc, [key]: params[key] }), {})
      const res = await getUserList(params)
      if (res && res.status === 0) {
        this.table.data = res.data.list
        this.table.pagination.total = res.data.total
      } else {
        this.$message.error(res.info.message)
      }
      this.table.loading = false
    },
    // 获取角色列表
    getRoleList () {
      getRoleList().then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.roleList = res.data
          } else {
            this.roleList = []
          }
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 切换页码 获取
    handleTableChange (pagination) {
      console.log('页码', pagination)
      this.table.pagination.pageNum = pagination
      this.searchModel = {
        ...this.searchModel,
        ...this.table.pagination
      }
      console.log(this.searchModel)
      this.initTableData()
    },
    onShowSizeChange (current, pageSize) {
      this.table.pagination.pageSize = pageSize
      this.searchModel = {
        ...this.searchModel,
        ...this.table.pagination
      }
      this.initTableData()
    },
    // 切换搜索参数 获取
    handleSearch (searchParams) {
      this.table.searchParams = searchParams
      this.table.pagination.pageNum = 1
      this.searchModel = {
        ...this.table.pagination,
        ...this.table.searchParams
      }
      this.initTableData()
    },
    // 配置角色
    configureRoles (data) {
      this.configureRolesId = data.id
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          roleUserList: data.roleIds
        })
      })
    },
    // 搜索角色
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input) >= 0
      )
    },
    // 关闭弹窗
    closeVisible () {
      this.confirmLoading = false
      this.visible = false
      this.configureRolesId = null
      this.form.resetFields()
    },
    // 提交配置角色表单
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = { ...values }
          const roleUserList = params.roleUserList.map(item => {
            return {
              roleId: item,
              userId: this.configureRolesId
            }
          })
          const data = {
            id: this.configureRolesId,
            roleUserList
          }
          this.confirmLoading = true
          saveUserRole(data).then(res => {
            if (res.status === 0) {
              this.initTableData()
              this.closeVisible()
              this.confirmLoading = false
            } else {
              this.$message.error(res.info.message)
              this.confirmLoading = false
            }
          })
            .catch(err => {
              this.$message.error(err.info.message)
              this.confirmLoading = false
            })
        }
      })
    }
  }
}

</script>

<style lang="less" scoped>
.subcompanyname {
  max-width: 11em;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.jobTitleName {
  max-width: 9em;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.assetNameTable {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
